import { gql } from '@apollo/client';

export const NOTIFICATION_FRAGMENT = gql`
  fragment Notification on Notification {
    id
    createdAt
    readAt
    topic
    workspaceId
    targets {
      ... on Resource {
        id
        name
      }
      ... on Workspace {
        id
        name
      }
      ... on Question {
        id
        title
      }
    }
  }
`;

const GET_MY_NOTIFICATIONS = gql`
  query GetMyNotifications(
    $filter: NotificationArgsFilter
    $limit: Int
    $offset: Int
    $sorter: NotificationArgsSorter
  ) {
    myNotifications(
      filter: $filter
      limit: $limit
      offset: $offset
      sorter: $sorter
    ) {
      nodes {
        ...Notification
      }
      pageInfo {
        totalCount
      }
      unreadCount
    }
  }
  ${NOTIFICATION_FRAGMENT}
`;

export default GET_MY_NOTIFICATIONS;
